import React from "react";
import { HashRouter as Router } from "react-router-dom";
import { toast, ToastContainer, Zoom } from "react-toastify";
import { Offline } from "react-detect-offline";
import axios, { AxiosRequestConfig } from "axios";

import RootRoutes from "./Routes/RootRoutes";
import { getToken, setToken, getRefreshToken, setRefreshToken, clearToken } from "./Services/storeToken";
import { ITokenPayload, TypeRefreshToken } from "./types";
import {
  getUserRole,
  isLoggedIn,
  logOut,
  refreshCurrentToken,
} from "./Services/UserAuth/UserAuthenticate";

import "./App.scss";
import "react-toastify/dist/ReactToastify.css";
import { JAVA_AUTH_API } from "./constants";
import { error } from "console";

export default function App() {
  // refresh token every 18 minutes when user is logged in
  async function refreshAccessToken() {
    if (!getToken() || !getRefreshToken()) {
      toast.error("Unauthorized. Logout from the app and try again.")
      logOut();
    }
    else {
      let PAYLOAD: ITokenPayload = {
        accessToken: getToken() ?? "",
        refreshToken: getRefreshToken() ?? ""
      };
      axios.post(`${JAVA_AUTH_API}auth/refresh`, PAYLOAD)
        .then((response) => {
          const TOKENS: ITokenPayload = response?.data;
          setToken(TOKENS?.accessToken);
          setRefreshToken(TOKENS?.refreshToken);
          return TOKENS?.accessToken;
        })
        .catch((err) => {
          console.log("refresh aPI errr is  ", err)
        })
    }

  };

  /* AXIOS INTERCEPTOR START */
  // -- interceptor for each requests --

  const pendingRequests = new Map();
  
  axios.interceptors.request.use(
    async (request: AxiosRequestConfig) => {
      let token = sessionStorage.getItem("Token");
      if (request.url && !request.url.includes("auth")) {
        request.headers.Authorization = "Bearer " + token;
      };
      // Check if the request is already in progress
    if (pendingRequests.has(request.url)) {
      // Abort the duplicate request
      const source = pendingRequests.get(request.url);
      source.cancel("Duplicate request detected.");
    }
     // Create a new Axios cancel token source for this request
     const source = axios.CancelToken.source();
     request.cancelToken = source.token;

     // Add the request to the pendingRequests map
     pendingRequests.set(request.url, source);
      return request;
    },
    (error) => {
      console.log("error while request is place",error)
      return Promise.reject(error);
    }
  );

  // -- interceptor for each response --

  axios.interceptors.response.use(
    undefined,
    (error)=> {
      console.log("Error.config.url is :", error);
      console.log("Error.status is :", error.response?.status);
      // Remove the completed request from the pendingRequests map
      const originalRequest = error?.config;
      pendingRequests.delete(originalRequest?.url);
      if (originalRequest?.url.includes("refresh"))
       {
        if(error.response?.status === 400 || error.response?.status === 401)
        {
          logOut()
        }
        // window.confirm(`${error.response?.status} ${error.config?.url}`)
      } else {
        // console.log("originalRequest is : ->",originalRequest._retry)
        if (error?.response?.status === 401 && isLoggedIn() && !originalRequest?._retry) {
          originalRequest._retry = true;
          return refreshAccessToken().then((token) => {
            originalRequest.headers.Authorization = `Bearer ${token}`;
            return axios(originalRequest);
          })
        }}
      return Promise.reject(error);
    }
  );

  return (
    <React.Fragment>
      <Router>
        <RootRoutes />
      </Router>

      {/* Network connection checking */}
      {/* <Offline polling={{ url: "https://ipv4.icanhazip.com" }}>
        <div
          className="offline"
          style={{
            position: "fixed",
            height: "50px",
            bottom: "0",
            left: "0",
            right: "0",
            fontSize: "20px",
            textAlign: "center",
            backgroundColor: "black",
            color: "white",
            opacity: 0.8
          }}
        >
          You are Offline!
        </div>
      </Offline> */}

      {/* Toast container */}
      <ToastContainer
        position="top-right"
        transition={Zoom}
        autoClose={3000}
        limit={2}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={true}
        pauseOnHover={true}
      />
    </React.Fragment>
  );
}
